import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";

import { DocumentTemplateApi } from "api";
import { useDocumentTypesOptions } from "api/hooks";
import {
  PaziaFormButton,
  PaziaInput,
  PaziaLoader,
  PaziaSelect,
} from "components/atoms";

interface DocumentTemplateFormProps {
  onSubmit: (data: DocumentTemplateFormValues) => Promise<void>;
  template?: DocumentTemplateApi;
  className?: string;
}
export const DocumentTemplateForm = ({
  onSubmit,
  template,
  className = "",
}: DocumentTemplateFormProps): JSX.Element => {
  const { loading, options } = useDocumentTypesOptions();

  const isEdit = !!template;
  const methods = useForm<DocumentTemplateFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      [FORM_NAMES.NAME]: template?.name ?? "",
      [FORM_NAMES.HEIGHT]: template?.height ?? "842pt",
      [FORM_NAMES.WIDTH]: template?.width ?? "595pt",
      [FORM_NAMES.DOCUMENT_TYPE_ID]: template?.type?.id,
    },
  });
  const { handleSubmit } = methods;

  if (loading) return <PaziaLoader position="center" />;
  return (
    <FormProvider {...methods}>
      <div className={`p-4 ${className} border-r border-r-slate-200 dark:border-r-slate-700 ${isEdit ?? "h-full"}`}>
        <form className="flex flex-col gap-2">
          <PaziaInput name={FORM_NAMES.NAME} label="Nazwa" type="text" required />
          <PaziaInput name={FORM_NAMES.WIDTH} label="Szerokość" type="text" required />
          <PaziaInput name={FORM_NAMES.HEIGHT} label="Wysokość" type="text" required />
          <PaziaSelect name={FORM_NAMES.DOCUMENT_TYPE_ID} label="Typ dokumentu" options={options} required />
        </form>
      </div>
      <div
        className={`flex justify-end p-4 ${className} ${
          isEdit ?? "border border-slate-200 bg-slate-100 dark:border-slate-700 dark:bg-slate-700"
        }`}
      >
        <PaziaFormButton title="Zapisz" onClick={() => handleSubmit(onSubmit)()} />
      </div>
    </FormProvider>
  );
};

const FORM_NAMES = {
  NAME: "name",
  WIDTH: "width",
  HEIGHT: "height",
  DOCUMENT_TYPE_ID: "documentTypeId",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.NAME]: yup.string().required(),
    [FORM_NAMES.WIDTH]: yup
      .string()
      .matches(/^\d+(\.\d+)?pt$/, "Szerokość musi być liczbą w formacie pt. (np. 595pt lub 100.5pt)")
      .required(),
    [FORM_NAMES.HEIGHT]: yup
      .string()
      .matches(/^\d+(\.\d+)?pt$/, "Wysokość musi być liczbą w formacie pt. (np. 842pt lub 100.5pt)")
      .required(),
    [FORM_NAMES.DOCUMENT_TYPE_ID]: yup.number().required(),
  })
  .required();

export type DocumentTemplateFormValues = yup.InferType<typeof schema>;
